import client from './client';

export interface ThankYouTemplate {
  id: string;
  name: string;
  subject: string;
  body: string;
  is_builtin: boolean;
}

export interface EmailDraft {
  subject: string;
  body: string;
  candidate_ids: number[];
  resend: boolean;
}

export interface EmailPreviewItem {
  candidate_id: number;
  candidate_name: string;
  job_title: string;
  email: string;
  current_stage: string;
  subject: string;
  body: string;
  eligible: boolean;
  reason: string;
  last_sent_at: string | null;
}

export interface EmailPreview {
  items: EmailPreviewItem[];
  sending_enabled: boolean;
  eligible_count: number;
  skipped_count: number;
  preview_token: string;
}

export interface EmailBatch {
  id: string;
  created_at: string;
  finished: boolean;
  counts: Record<string, number>;
  items: Array<{
    candidate_id: number;
    candidate_name: string;
    job_title: string;
    email: string;
    status: string;
    reason: string;
    sent_at: string | null;
  }>;
}

const base = '/candidate-email';
export const getThankYouTemplates = async (): Promise<ThankYouTemplate[]> => (await client.get(`${base}/templates`)).data;
export const saveThankYouTemplate = async (name: string, subject: string, body: string): Promise<ThankYouTemplate> =>
  (await client.post(`${base}/templates`, { name, subject, body })).data;
export const deleteThankYouTemplate = async (id: string): Promise<void> => { await client.delete(`${base}/templates/${id}`); };
export const previewThankYouEmail = async (draft: EmailDraft): Promise<EmailPreview> =>
  (await client.post(`${base}/thank-you/preview`, draft)).data;
export const sendThankYouEmail = async (draft: EmailDraft, preview_token: string, request_id: string): Promise<EmailBatch> =>
  (await client.post(`${base}/thank-you/batches`, { ...draft, preview_token, request_id })).data;
export const getThankYouBatch = async (id: string): Promise<EmailBatch> => (await client.get(`${base}/thank-you/batches/${id}`)).data;
export const getRecentThankYouBatches = async (): Promise<Array<{ id: string; created_at: string }>> =>
  (await client.get(`${base}/thank-you/batches`)).data;
